import { render, staticRenderFns } from "./DetailContent.vue?vue&type=template&id=3ed57a1c&scoped=true"
import script from "./DetailContent.vue?vue&type=script&lang=ts"
export * from "./DetailContent.vue?vue&type=script&lang=ts"
import style0 from "./DetailContent.vue?vue&type=style&index=0&id=3ed57a1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed57a1c",
  null
  
)

export default component.exports